import axios from "axios";

const VehiclePassagesSearchService = {
    getBrandModelsTranslation: async (data) => axios.get("/archiverProxy/1/brandModels", data).then(({data}) => data).catch((err) => { throw err })
}

export default VehiclePassagesSearchService;
